import React, { useEffect, useState } from 'react'
// import Modal from '../../../components/Modal'
import Modal from 'react-responsive-modal'
import styles from '../styles.module.css'
import Button from '../../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Input, Select, } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import Table from '../../../../components/Table'
import { createParentMeetings, getParentMeetingFileList, getParentMeetingsRooms, getParentMeetingFile, updateParentMeetings } from '../../../../actions/parent_meetings'
import TeacherModal from '../EnrollModal/TeacherModal'
import { getSchoolClassByYear } from '../../../../actions/common'
import moment from 'moment'
import { getGroups } from '../../../../actions/groups'


// const validationSchema = Yup.object().shape({
//   date: Yup.string().required('обязательное поле'),
//   begintime: Yup.string().required('обязательное поле'),
//   endtime: Yup.string().required('обязательное поле')
// })

export default function Main({ data, closeModal, params, addMode, handleChange, values, touched, submitCount, errors, handleBlur, handleSubmit, handleChangeClasses, selectedClasses, setSelectedClasses }) {

  const dispatch = useDispatch()
  const { groupsEnd, } = useSelector(state => state.groups)

  const { parentMeetingsRooms, parentMeetingsTeachers, parentMeetingsId } = useSelector(state => state.parent_meetings)

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  // const [selectedClasses, setSelectedClasses] = useState([])

  useEffect(() => {
    !addMode && parentMeetingsId && setSelectedClasses(groupsEnd?.filter(el => parentMeetingsId.classes?.find(num => num == el.name)))
  }, [parentMeetingsId])

  useEffect(() => {
    dispatch(getParentMeetingsRooms())
    dispatch(getGroups(1)) // список групп-классов актуальный
    data?.pmid && dispatch(getParentMeetingFileList(data?.pmid)) // список файлов для отрисовки таб с файлами
  }, [])

  useEffect(() => {
    if (params.year) {
      dispatch(getSchoolClassByYear(params.year))
    }
  }, [params])



  // const handleCreate = (values) => {
  //   const classesId = !!selectedClasses && selectedClasses?.map(el => el.gid)
  //   dispatch(createParentMeetings(values, { classes: classesId }, params))
  //   closeModal()
  //   setSelectedClasses([])
  //   resetForm()
  // }

  // const handleUpdate = (values) => {
  //   // const { week_id, ...payload } = values
  //   const classesId = !!selectedClasses && selectedClasses?.map(el => el.gid)
  //   dispatch(updateParentMeetings({ ...values, classes: classesId, date: moment(values.date).format('YYYY-MM-DD') }))
  //   closeModal()
  //   setSelectedClasses([])
  //   resetForm()
  // }
  const openEnroll = () => {
    setOpenEnrollModal(groupsEnd)
  }
  const closeEnroll = () => {
    setOpenEnrollModal(false)
  }

  const closeModalEmpty = () => {
    closeModal()
    // setSelectedClasses([])
  }

  // const {
  //   values,
  //   errors,
  //   touched,
  //   submitCount,
  //   handleBlur,
  //   handleChange,
  //   handleSubmit,
  //   resetForm,
  // } = useFormik({
  //   initialValues: addMode ? { date: moment().format('YYYY-MM-DD') } : data,
  //   enableReinitialize: true,
  //   validateOnChange: true,
  //   validationSchema: validationSchema,
  //   onSubmit: addMode ? handleCreate : handleUpdate,

  // })

  const renderLi = (data) => {
    const { name, pmgid, teacher, calc_classroom_teacher } = data
    return (
      <tr key={pmgid}>
        <td>{name}</td>
        <td>{teacher || calc_classroom_teacher}</td>
      </tr>
    )
  }

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <>
      {openEnrollModal &&
        <TeacherModal
          closeModal={closeEnroll}
          data={openEnrollModal}
          height={'430px'}
          handleChangeClasses={handleChangeClasses}
          selectedClasses={selectedClasses}
        />
      }
      <div className={styles.tabWrapper}>
        <div className={styles.inputsRow}>
          <Input
            label='Дата'
            name='date'
            type='date'
            value={moment(values?.date).format('YYYY-MM-DD') || values?.date}
            // error={error('date')}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Начало'
            name='begintime'
            type='time'
            error={error('begintime')}
            value={values?.begintime}
            onChange={handleChange}
          />
          <Input
            label='Окончание'
            name='endtime'
            type='time'
            error={error('endtime')}
            value={values?.endtime}
            onChange={handleChange}
          />
        </div>
        <br />
        <br />
        <Select
          label="Кабинет"
          name={"rid"}
          value={values?.rid}
          withoutArrowMode
          onChange={handleChange}
        >
          <option value='0' >Выбрать</option>
          {parentMeetingsRooms &&
            parentMeetingsRooms?.map(el => <option key={el.rid || el.xp_key} value={el.rid || el.xp_key}>{el.name || el.title}</option>
            )}
        </Select>
        <br />
        <Button style={{ margin: '10px 0px 0px auto' }} onClick={openEnroll}>Добавить</Button>
        <br />
        <Table className={styles.tables}>
          <thead>
            <tr>
              <th>Класс</th>
              <th>Классный руководитель</th>
            </tr>
          </thead>
          <tbody>
            {selectedClasses?.map(renderLi)}
          </tbody>
        </Table>

      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModalEmpty} />
    </>
  )
}
